export default {
  //千分符
  numFormat(num) {
    var c =
      num.toString().indexOf(".") !== -1
        ? num.toLocaleString()
        : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    return c;
  },
  //文字超出省略号
  stringLength(string){
   var s=string.length>6?(string.slice(0,6)+'...'):string
    return s
  },
   //换行符取消
   backLine(string){
    var s= string.replace(/\<br\/\>/g,"")
    return s
  }
};
